

const CaptionImages = ({ images, selectImage }) => {

  return <div className="flex flex-wrap w-full z-0">
    {images.map(image => <div key={image.mediaId} className="group w-1/4 relative p-1 mb-2 " >
      <button onClick={selectImage} id={image.mediaId}>
        <div className="flex justify-center w-full">
          <img loading="lazy" src={image.imageUrl} className="h-80 w-auto" />
        </div>
        <div className="px-2">
          <p>{new Date(image.timeStamp).toDateString()}</p>
          <p><a href={'https://www.instagram.com/' + image.username} target="_blank" className="text-blue-400 hover:text-blue-500">{image.username}</a></p>
          <p><a href={image.postUrl} target="_blank" className="text-blue-400 hover:text-blue-500">Post URL</a></p>
        </div>
      </button>
    </div>)}
  </div>

}

export default CaptionImages
